/**
 * Context menu actions for agent-job nodes in the Object Explorer tree.
 */

import type { AgentJobNodeMetadata } from '../../explorer/models/nodeTypes';
import { openAgentWorkspace } from './agentContextMenuHelper';
import { toast } from '../../../components/ui/toaster';

export function executeAgentJobContextMenuAction(
  actionId: string,
  metadata: AgentJobNodeMetadata,
  callbacks: { onRefresh: () => void },
) {
  switch (actionId) {
    case 'open-job':
      openAgentWorkspace(metadata.connectionId, 'jobs');
      break;
    case 'run-job':
      void startJobFromExplorer(metadata);
      break;
    case 'toggle-job':
      void toggleJobFromExplorer(metadata, callbacks.onRefresh);
      break;
  }
}

async function startJobFromExplorer(metadata: AgentJobNodeMetadata) {
  const api = window.electronAPI?.jobScheduler;
  if (!api) {
    toast.error({ title: 'Job Scheduler not available' });
    return;
  }

  try {
    const result = await api.startJob({ connectionId: metadata.connectionId, jobId: metadata.jobId });
    if (result.success) {
      toast.success({ title: `Job "${metadata.jobName}" started` });
    } else {
      toast.error({ title: 'Failed to start job', description: result.error });
    }
  } catch (error) {
    toast.error({
      title: 'Failed to start job',
      description: error instanceof Error ? error.message : 'Unknown error',
    });
  }
}

async function toggleJobFromExplorer(metadata: AgentJobNodeMetadata, onRefresh: () => void) {
  const api = window.electronAPI?.jobScheduler;
  if (!api) {
    toast.error({ title: 'Job Scheduler not available' });
    return;
  }

  try {
    const result = await api.toggleJobEnabled({
      connectionId: metadata.connectionId,
      jobId: metadata.jobId,
      enabled: !metadata.enabled,
    });
    if (result.success) {
      const action = !metadata.enabled ? 'enabled' : 'disabled';
      toast.success({ title: `Job "${metadata.jobName}" ${action}` });
      onRefresh();
    } else {
      toast.error({ title: 'Failed to toggle job', description: result.error });
    }
  } catch (error) {
    toast.error({
      title: 'Failed to toggle job',
      description: error instanceof Error ? error.message : 'Unknown error',
    });
  }
}
